
import React, { useMemo, memo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMarketing } from '../../../../state/MarketingContext';

interface CategoriesRailProps {
    populatedCategories?: Set<string>;
}

export const CategoriesRail = memo(({ populatedCategories }: CategoriesRailProps) => {
    const navigate = useNavigate();
    const { categories } = useMarketing();
    
    const activeCategories = useMemo(() => 
        categories
            .filter(c => c.isActive)
            .sort((a, b) => a.order - b.order), 
    [categories]);

    const getStyles = (colorClass: string | undefined, isPopulated: boolean) => {
        const baseBox = 'bg-surface-light dark:bg-white/5 transition-all';
        const opacityClass = isPopulated ? 'opacity-100' : 'opacity-40 grayscale-[0.5]';
        
        if (!colorClass) return { 
            box: `${baseBox} ${opacityClass}`, 
            icon: 'text-text-main dark:text-white',
            pulse: false
        };
        
        return {
            box: `${baseBox} ${opacityClass}`,
            icon: `${colorClass} dark:text-white`,
            pulse: !isPopulated
        };
    };

    return (
        <div className="w-full py-4">
            <div className="grid grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-y-6 gap-x-2 justify-items-center">
                {activeCategories.map((cat) => {
                    const isPopulated = !populatedCategories || populatedCategories.size === 0 || populatedCategories.has(cat.name);
                    const styles = getStyles(cat.color, isPopulated);
                    
                    return (
                        <div key={cat.id} onClick={() => navigate('/catalog', { state: { category: cat.name } })} className="flex flex-col items-center gap-2 cursor-pointer group w-[72px]">
                            <div className={`relative w-[72px] h-[72px] rounded-2xl shadow-[0_4px_12px_rgba(0,0,0,0.05)] dark:shadow-none flex items-center justify-center group-hover:-translate-y-1 duration-300 ${styles.box}`}>
                                <span className={`material-symbols-outlined text-[30px] ${styles.icon}`}>{cat.icon}</span>
                                {!isPopulated && (
                                    <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center">
                                        <span className="material-symbols-outlined text-[12px] text-gray-500 dark:text-gray-400">close</span>
                                    </div>
                                )}
                            </div>
                            <p className={`text-text-main dark:text-gray-300 text-[10px] font-bold text-center leading-tight truncate w-full ${isPopulated ? 'opacity-100' : 'opacity-50'}`}>{cat.name}</p>
                            {!isPopulated && (
                                <p className="text-[8px] text-gray-400">Sin productos</p>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
});
CategoriesRail.displayName = 'CategoriesRail';
